export const setSortValue = (value) => {
	return {
		type: 'SET_SORT_VALUE',
		value
	}
}

export const setSortDirection = (dir) => {
	return {
		type: 'SET_SORT_DIR',
		dir
	}
}

export const setSortValueAndDirection = (value, dir) => {
	return {
		type: 'SET_SORT_VALUE_AND_DIR',
		dir,
		value
	}
}



// WEBPACK FOOTER //
// ./src/store/actions/sort.js